import { useEffect, useState } from 'react';
import { useI18n } from '../../hooks/useI18n';
import { apiPaymentMethodLogos } from '../../lib/api';
import { brandLogoSrc } from '../../lib/logodev';
import { DEFAULT_PAYMENT_METHOD_LOGOS } from '../../lib/paymentMethods';
import type { PaymentMethodLogo } from '../../types';

export function PaymentLogoCard({ logos = DEFAULT_PAYMENT_METHOD_LOGOS }: { logos?: PaymentMethodLogo[] }) {
  const { t } = useI18n();
  const visible = logos.filter((logo) => !!logo.enabled).sort((a, b) => a.sort_order - b.sort_order || a.name.localeCompare(b.name));
  return (
    <div className="flex w-fit max-w-full flex-wrap items-center justify-center gap-2 rounded-2xl border border-glass-line/25 bg-gradient-to-br from-white/75 via-white/55 to-brand/25 px-3 py-2.5 shadow-sm shadow-canvas/30 backdrop-blur-md sm:gap-3 sm:px-4" aria-label={t('detail_payment_methods')}>
      {visible.map((logo) => <img key={logo.id} src={brandLogoSrc(logo.logo_type, logo.logo_value, logo.name)} alt={logo.name} className="h-8 w-auto object-contain sm:h-9" loading="lazy" />)}
    </div>
  );
}

export default function PaymentMethodsStrip({ fetchLogos = true, logos }: { fetchLogos?: boolean; logos?: PaymentMethodLogo[] }) {
  const [items, setItems] = useState<PaymentMethodLogo[]>(logos || DEFAULT_PAYMENT_METHOD_LOGOS);

  useEffect(() => {
    if (!fetchLogos || logos) return;
    let cancelled = false;
    apiPaymentMethodLogos().then((next) => {
      if (!cancelled && next.length) setItems(next);
    }).catch(() => {
      if (!cancelled) setItems(DEFAULT_PAYMENT_METHOD_LOGOS);
    });
    return () => { cancelled = true; };
  }, [fetchLogos, logos]);

  return <PaymentLogoCard logos={logos || items} />;
}
